<template>
  <v-container fluid>
    <v-row class="device_details" :class="!$route.params.deviceId ? '' : 'pl-3 pr-3'">
      <v-col cols="12" class="text-body-1 pt-0 pb-0 backgroundLight">
        <v-toolbar class="add-opacity" color="backgroundLight" :flat="true">
          <v-toolbar-title v-if="!$route.params.locationId" class="title primaryGrey--text">
            <router-link :to="`/location/${locationId}`">
              <v-icon class="mr-3" small color="primaryGrey">mdi-open-in-new</v-icon>Open as a Page
            </router-link>
          </v-toolbar-title>
          <v-toolbar-title v-if="$route.params.locationId" class="title primaryGrey--text">
            <router-link :to="`/locations`">
              <v-icon class="mr-3" color="primaryGrey">mdi-keyboard-backspace</v-icon>Back
            </router-link>
            <v-btn small color="vtblue" @click="dialog = true" dark fixed right fab>
              <v-icon small>mdi-export</v-icon>
            </v-btn>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row class="common-card-row">
      <v-col cols="12" md="8" class="pa-0 pb-3 pr-md-3 pb-md-0">
        <v-col class="common-card-col">
          <v-row no-gutters>
            <v-col cols="11">
              <div class="font-weight-bold">
                {{ computed_location_details.FullName }}
                <v-chip
                  dark
                  x-small
                  class="ml-2 mb-1"
                  v-if="computed_location_details.LocationCategory"
                  color="primaryGrey"
                >
                  {{ computed_location_details.LocationCategory }}
                </v-chip>

                <router-link class="no-style" target="_blank" to="/alerts">
                  <v-icon color="vtred" class="pl-2 pb-1 pointer" title="Manage alerts" small>mdi-bell-plus</v-icon>
                </router-link>
              </div>
              <div v-if="computed_location_details.LocationAddress1">
                {{ computed_location_details.LocationAddress1 }}
              </div>
              <div v-if="computed_location_details.Latitude" class="d-flex mt-1 text-caption primaryGrey--text">
                <div>
                  <v-icon class="mr-1" color="primary" small>mdi-latitude</v-icon
                  >{{ computed_location_details.Latitude }}
                </div>
                <div class="ml-3">
                  <v-icon class="mr-1" color="primary" small>mdi-longitude</v-icon
                  >{{ computed_location_details.Longitude }}
                </div>
              </div>
            </v-col>
            <v-col cols="1" class="text-right">
              <v-icon>{{ computed_location_details.IsWatchlisted ? "mdi-star" : "mdi-star-outline" }}</v-icon>
            </v-col>
          </v-row>
          <v-row no-gutters class="pl-0 pr-5 pt-4 info-container">
            <v-col cols="4" class="font-weight-bold">
              <div class="text-caption">Total Assets On Location</div>
              {{ total_assets }}
            </v-col>
            <v-col cols="4" class="pl-4 font-weight-bold">
              <div class="text-caption">Fluid Assets</div>
              <div class="primaryDark--text text-h6">
                {{ device_status["Fluid"] }}
                <span class="primaryGrey--text text-caption"
                  >{{ get_percentage(total_assets, device_status["Fluid"]) }}%</span
                >
              </div>
            </v-col>
            <v-col cols="4" class="pl-4 font-weight-bold">
              <div class="text-caption">Static Assets</div>
              <div class="primaryDark--text text-h6">
                {{ device_status["Static"] }}
                <span class="primaryGrey--text text-caption"
                  >{{ get_percentage(total_assets, device_status["Static"]) }}%</span
                >
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters class="pl-0 pr-5 mt-2 info-container">
            <v-col cols="4" class="font-weight-bold">
              <div class="text-caption">Rate of Flow</div>
              <div>
                {{ $percentage(computed_location_details.FlowRate) }}
              </div>
            </v-col>
            <v-col cols="4" class="pl-4 font-weight-bold">
              <div class="text-caption">% Of Fleet At This Location</div>
              <div>{{ get_percentage(total_fleet_assets, total_assets) }}%</div>
            </v-col>
            <v-col cols="4" class="pl-4 font-weight-bold">
              <div class="text-caption">Avg. Stay Duration</div>
              <div>
                {{ computed_location_details.Utilisation | timeSince }}
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters class="pl-0 pr-5 mt-2 mb-1 info-container">
            <v-col cols="8" class="font-weight-bold">
              <div class="text-caption">Comments</div>
              <div>
                {{ $emptyCheck(computed_location_details.Comment) }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
      <v-col cols="12" md="4" class="pa-0">
        <v-col class="common-card-col">
          <MapsVT
            v-if="page_content && computed_location_details"
            height="25vh"
            :options="page_content.maps_config_poi"
            :items="[computed_location_details]"
            :center="get_center"
            :hide_legends="hide_legends"
            :showRoute="!hide_legends"
            :clusterMarkers="hide_legends"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="common-card-row pb-3">
      <v-col cols="12" class="pa-0 pb-3 pb-md-0">
        <v-col class="common-card-col">
          <PrimaryFiltersVT
            :list_filters="computed_tabs"
            @filter_update="update_current_tab($event)"
            :current_tab="current_tab"
          />
          <v-row v-if="current_tab == 'POIDashboard'" no-gutters>
            <v-col cols="8" class="right-border pt-3">
              <v-row class="pt-5 pb-3" no-gutters>
                <v-col
                  cols="auto"
                  @click="poi_dashboard = 'duration'"
                  :class="`px-2 mr-2 text-subtitle-1 font-weight-bold dashboard_tab ${
                    poi_dashboard == 'duration' ? 'tab-highlighted' : ''
                  }`"
                  >Stay Duration</v-col
                >
              </v-row>
              <ColumnChartVT xlabel="Static Stay Time" ylabel="Number of Assets" :chartData="stay_duration">
              </ColumnChartVT>
            </v-col>
            <v-col cols="4" class="pl-6 pt-3">
              <v-row>
                <v-col cols="6" class="text-subtitle-1 font-weight-bold">Assets Arriving Time</v-col>
                <v-col cols="6">
                  <v-select
                    v-if="page_content"
                    class="text-caption"
                    v-model="asset_arrival_week"
                    :items="page_content.assets_arrival_duration_select"
                    item-text="label"
                    item-value="value"
                    outlined
                    height="30px"
                    dense
                    color="borderLight"
                    @change="get_assests_stats()"
                  ></v-select>
                </v-col>
              </v-row>
              <div v-if="page_content" class="mt-1 mb-3">
                <div v-for="(item, index) in page_content.arrival_time.time" :key="`row_${index}`" class="d-flex">
                  <div
                    :class="`add-border fixd-tile mr-3 mb-1 rounded-sm ${get_color_indicator(
                      timely_distribution[item.value],
                      day.value
                    )}`"
                    v-for="(day, idx) in page_content.arrival_time.days"
                    :key="`row_${idx}`"
                    :title="`${
                      (timely_distribution[item.value] && timely_distribution[item.value][day.value]) || 0
                    } Asset(s)`"
                  ></div>
                  <div class="ml-1 graph-sub-heading">{{ item.label }}</div>
                </div>
                <div class="d-flex">
                  <div
                    v-for="(day, idx) in page_content.arrival_time.days"
                    :key="`heading_${idx}`"
                    class="d-flex justify-center graph-sub-heading mr-3 mt-1 fixd-tile"
                  >
                    {{ day.label }}
                  </div>
                </div>
                <div class="d-flex pt-4 pb-2">
                  <div v-for="(color, idx) in arrival_time_color" :key="`colors_${idx}`" class="mr-3">
                    <div :class="`${color.color}`" class="fixd-legend-tile"></div>
                    <div class="text-right text-caption primaryDark--text">
                      {{ color.max }}
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="current_tab != 'POI Dashboard'">
            <v-col cols="12" class="pt-7">
              <DataTableVT
                v-if="current_tab == 'Devices'"
                :headers="page_content.devices_table"
                :items_list="devices_list"
                @rowClick="open_details($event)"
                :no_search="no_search"
              />
              <DataTableVT
                v-if="current_tab == 'Journeys'"
                :headers="page_content.journeys_table"
                :items_list="journeys_list"
                :no_search="no_search"
              />
              <v-row class="pb-3 px-10" no-gutters v-if="current_tab == 'CycleAnalysis'">
                <v-col cols="10">
                  <div cols="12" class="text-h5 mb-8 primary--text">
                    Statistics
                    <span class="text-subtitle-1">(Last {{ cycle_duration }} Weeks)</span>
                  </div>
                  <v-row no-gutters class="pb-2 font-weight-bold">
                    <v-col cols="2">
                      <div class="text-caption">Avg Cycle time</div>
                      <div class="primaryDark--text text-h6">
                        {{ avg_cycle_time | timeSince }}
                      </div>
                    </v-col>
                    <v-col cols="2">
                      <div class="text-caption">Total Cycles</div>
                      <div class="primaryDark--text text-h6">
                        {{ cycles_list ? cycles_list.length : null }}
                      </div>
                    </v-col>
                    <v-col cols="2">
                      <div class="text-caption">Devices invloved in Cycles</div>
                      <div class="primaryDark--text text-h6">
                        {{ total_cycles_devices }}
                      </div>
                    </v-col>
                    <v-col cols="2" class="pointer pointer-con" @click="redirectToDevice('outside')">
                      <div class="text-caption">Devices Outside Network</div>
                      <div class="value-con primaryDark--text text-h6">
                        {{ outside_network }}
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <div class="d-flex flex-column justify-space-between align-end">
                    <div>
                      <v-select
                        class="text-caption"
                        v-model="cycle_duration"
                        :items="page_content.assets_cycle_duration_select"
                        item-text="label"
                        item-value="value"
                        outlined
                        height="30px"
                        dense
                        color="borderLight"
                        @change="
                          computed_cycles_list1 = null;
                          get_cycle_data();
                          fetchCycleChartData();
                        "
                      ></v-select>
                    </div>
                    <div class="">
                      <v-checkbox
                        small
                        class="font-weight-light mt-0 mb-4"
                        v-model="includeMidCycle"
                        label="Include Mid Cycle"
                        color="primaryDark"
                        hide-details
                        @change="
                          get_cycle_data();
                          fetchCycleChartData();
                        "
                      ></v-checkbox>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-row class="px-10 bottom-border top-border" no-gutters>
                    <v-col
                      :cols="`${includeMidCycle ? 8 : 12}`"
                      :class="`${includeMidCycle ? 'right-border pb-2' : 'pb-2'}`"
                    >
                      <div class="text-h6 primaryDark--text pt-3">Cycle Time Analysis</div>
                      <LineChartVT
                        :chartData="cycles_overtime_list"
                        ylabel="Average Cycle Time"
                        xlabel="Week"
                        lineWidth="0.6"
                        pointSize="0.6"
                        dataOpacity="1"
                      ></LineChartVT>
                    </v-col>
                    <v-col cols="4" v-if="includeMidCycle">
                      <RadialChartVT
                        :v-if="donut_data"
                        :chartData="donut_data"
                        title="Devices Status"
                        @on-click="apply_graph_filter($event)"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <DataTableVT
                        v-if="computed_cycles_list1"
                        :headers="page_content.cycles_table"
                        :items_list="computed_cycles_list1"
                        item_key="DeviceID"
                        expand="true"
                        :no_search="no_search"
                        :loading="is_loading"
                      >
                        <template v-slot:default="cycle">
                          <v-card outlined>
                            <DataTableVT
                              dense="true"
                              class="mx-6 my-2"
                              no_export="true"
                              expand="true"
                              v-if="cycle.item.DeviceID && cycle.item.cycles.length > 0"
                              :headers="page_content.cycles_data"
                              :items_list="cycle.item.cycles"
                              item_key="id"
                              :no_search="no_search"
                              @expandRow="fetchCycleDetails($event)"
                            >
                              <template v-slot:default="cycle_data">
                                <v-card outlined>
                                  <DataTableVT
                                    v-if="cycle_data.item.cycle_details.length > 0"
                                    sort_by="sno"
                                    :sort_asc="sort_asc"
                                    dense="true"
                                    class="mx-6 my-2"
                                    no_export="true"
                                    :headers="page_content.cycles_details"
                                    :items_list="cycle_data.item.cycle_details"
                                    item_key="LocationHistoryID"
                                    :no_search="no_search"
                                    :loading="is_loading_details"
                                  ></DataTableVT> </v-card
                              ></template>
                            </DataTableVT>
                          </v-card>
                        </template>
                      </DataTableVT>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </v-row>
    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        class="backgroundWhite pt-11 px-8 pb-8"
        style="width: 780px; max-height: 80vh; overflow: auto"
      >
        <div class="download-btn">
          <v-btn color="vtblue" icon right @click="exportPDF">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </div>
        <div class="close-btn">
          <v-btn class="py-4" outlined x-small color="restingOutline" right @click="closeDialog">
            <v-icon small color="primaryGrey">close</v-icon>
          </v-btn>
        </div>
        <div class="pa-0" style="overflow: auto; height: 100%; max-width: 100%" ref="poisnapshot">
          <POISnapshot></POISnapshot>
        </div>
      </v-card>
    </v-overlay>
  </v-container>
</template>

<script>
import MapsVT from "../components/MapsVT";
import DataTableVT from "../components/DataTableVT";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import ColumnChartVT from "../components/ColumnChartVT";
import POISnapshot from "../components/POISnapshot";
import html2pdf from "html2pdf.js";
import LineChartVT from "../components/LineChartVT";
import RadialChartVT from "../components/RadialChartVT";
import { axios_get } from "../services/vt_service";
import { tracking } from "../services/tracking";
import { content } from "../../config/locations.js";

export default {
  props: ["location_detail"],
  watch: {},
  name: "Location",
  components: {
    MapsVT,
    DataTableVT,
    PrimaryFiltersVT,
    ColumnChartVT,
    POISnapshot,
    LineChartVT,
    RadialChartVT,
  },
  data: function () {
    return {
      max_inactive_assets: 0,
      device_status: {
        Fluid: 0,
        Static: 0,
      },
      filter_conditions: {},
      primary_filter_conditions: "",
      locationId: null,
      flat: true,
      includeMidCycle: true,
      hide_legends: true,
      network_error: false,
      devices_list: [],
      device_data: [],
      current_position: {},
      current_battery_icon: "battery-full",
      has_coordinates: false,
      chartData: [],
      page_content: null,
      location_details: {},
      watchlisted_devices: [],
      dialog: false,
      line_chart_data: [],
      timely_distribution: {},
      asset_arrival_week: null,
      poi_dashboard: "duration",
      stay_duration: [],
      journeys_list: [],
      cycles_list: [],
      total_cycles: 0,
      total_cycles_devices: 0,
      cycles_overtime_list: [],
      no_search: true,
      cycle_details: null,
      sort_asc: true,
      cycle_details1: null,
      cycle_duration: null,
      computed_cycles_list1: [],
      status_chart_data: [],
      chartOptions: {
        chart: {
          title: "Device Signals",
          subtitle: "Messages received (last 7 days)",
        },
      },
      is_loading_details: false,
      is_loading: false,
      current_tab: "POIDashboard",
    };
  },
  mounted() {
    this.page_content = content;
    this.asset_arrival_week = "1";
    this.cycle_duration = "4";

    this.line_chart_data = [
      ["Weekly Stats", "Inactive Assets", { role: "tooltip", type: "string", p: { html: true, role: "tooltip" } }],
    ];
    this.stay_duration = [
      [
        "Assets stay duration over time",
        "Fluid Assets",
        "Static Assets",
        { role: "tooltip", type: "string", p: { html: true, role: "tooltip" } },
      ],
    ];
    this.on_load_fetch_data();
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    exportPDF() {
      var opt = {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: "poi_snapshot_" + new Date().toString() + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          dpi: 190,
          letterRendering: true,
        },
        jsPDF: { unit: "in", format: "a4", orientation: "p" },
        pagebreak: {
          mode: ["avoid-all", "css", "legacy"],
        },
      };
      html2pdf()
        .from(this.$refs.poisnapshot)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function () {
          //Customization
        })
        .save();
      window.setTimeout(() => {
        this.dialog = false;
        this.$store.commit("hide_loader");
      }, 1000);
    },
    get_percentage(total, val) {
      return Math.round((val / total) * 10000) / 100;
    },
    open_details(item) {
      this.$router.push("/device/" + item["DeviceID"]);
    },
    get_color_indicator(value, day) {
      let current_value = (value && value[day]) || 0;
      let filtered_color = this.arrival_time_color.filter((elem) => {
        return current_value < elem.max && current_value >= elem.min;
      });
      return (filtered_color && filtered_color[0] && filtered_color[0].color) || "restingOutline";
    },
    redirectToDevice(param) {
      this.$router.push({
        name: "Devices",
        params: {
          search: param,
        },
      });
    },
    apply_graph_filter(filterObj) {
      switch (filterObj) {
        case "Mid Cycle": {
          let filteredList = this.cycles_list.filter(
            (elem) => elem.StartPoint != elem.FinalPoint && elem.TripTime <= 9 * 24
          );
          this.compute_cycle_list(filteredList);
          this.total_cycles = filteredList.length;
          break;
        }
        case "At Plant": {
          this.current_tab = "Devices";
          break;
        }
        case "Slow Devices":
          {
            let filteredList = this.cycles_list.filter(
              (elem) => elem.StartPoint != elem.FinalPoint && elem.TripTime > 9 * 24
            );
            this.compute_cycle_list(filteredList);
            this.total_cycles = filteredList.length;
          }
          break;
        default: {
          this.total_cycles = this.cycles_list.length;
          this.compute_cycle_list(this.cycles_list);
        }
      }
    },
    update_current_tab: function (tab) {
      this.current_tab = tab;
      if (tab == "CycleAnalysis") {
        this.cycle_details = {};
        this.get_cycle_data();
        this.fetchCycleChartData();
      }
    },
    fetchCycleDetails: async function (item) {
      this.is_loading_details = true;
      const response = await axios_get(tracking.fetchCycleDetails, {
        DeviceID: item.DeviceID,
        startDate: item.LastSeenAtOrigin,
        endDate: item.ArrivalTimeAtDestination,
      });
      this.cycle_details[`${item.DeviceID}_${item.LastSeenAtOrigin}_${item.ArrivalTimeAtDestination}`] = response.map(
        (elem, indx) => {
          elem.id = `${elem.DeviceID}_${elem.EntryTime}`;
          elem.sno = indx + 1;
          elem.TripDuration = this.$options.filters.timeSince(elem.TripDuration);
          return elem;
        }
      );
      this.$set(this.computed_cycles_list1, this.update_cycle_list(this.computed_cycles_list1));
      this.computed_cycles_list1 = this.update_cycle_list(this.computed_cycles_list1);
      this.is_loading_details = false;
    },
    fetchCycleChartData: async function () {
      if (this.includeMidCycle) {
        this.status_chart_data = [];
        const response = await axios_get(tracking.fetchCycleChartData, {
          cycleDuration: this.cycle_duration,
          locationId: this.locationId,
        });
        this.status_chart_data = response;
      }
    },
    format_graph_data(response) {
      let assets_stay_duration = {
        Fluid: [],
        "Static <= 1 Week": [],
        "Static <= 1 Month": [],
        "Static > 1 Month": [],
      };
      for (let i = 0; i < response.length; i++) {
        this.device_status[response[i]["DeviceStatus"]]++;
        if (response[i]["StayDuration"] < 72) {
          assets_stay_duration["Fluid"].push(response[i]);
        } else if (response[i]["StayDuration"] >= 72 && response[i]["StayDuration"] <= 168) {
          assets_stay_duration["Static <= 1 Week"].push(response[i]);
        } else if (response[i]["StayDuration"] > 168 && response[i]["StayDuration"] <= 720) {
          assets_stay_duration["Static <= 1 Month"].push(response[i]);
        } else if (response[i]["StayDuration"] > 720) {
          assets_stay_duration["Static > 1 Month"].push(response[i]);
        }
      }
      for (const property in assets_stay_duration) {
        let active = assets_stay_duration[property].filter((elem) => elem["DeviceStatus"] == "Fluid");
        let inactive = assets_stay_duration[property].filter((elem) => elem["DeviceStatus"] == "Static");
        this.stay_duration.push([property, active.length || 0, inactive.length || 0, ""]);
      }
    },
    async on_load_fetch_data() {
      this.location_detail ? this.get_device_data() : this.get_location_data();
      this.get_assests_stats();
    },
    async get_device_data() {
      this.network_error = false;
      this.locationId = this.$route.params.locationId || (this.location_detail && this.location_detail.LocationID);
      this.get_journeys_data();
      const response = await axios_get(tracking.fetch_devices_at_POI, { id: this.locationId });
      this.format_graph_data(response);
      this.devices_list = response;
    },
    async get_journeys_data() {
      this.network_error = false;
      const response = await axios_get(tracking.get_journeys_data);
      this.journeys_list = this.filter_journeys_data(response);
    },
    compute_cycle_list(cycle_list) {
      let temp = {};
      let tempList = [];
      let list = [];
      cycle_list.map((elem) => {
        if (tempList.indexOf(elem.DeviceID) != -1) {
          temp[elem.DeviceID].push(elem);
        } else {
          temp[elem.DeviceID] = [elem];
          tempList.push(elem.DeviceID);
        }
      });
      Object.keys(temp).forEach((key) => {
        let avgTime = 0;
        let maxTime = 0;
        let cyclesList = [];
        temp[key].map((elem) => {
          avgTime = avgTime + elem.TripTime;
          elem.id = `${elem.DeviceID}_${elem.LastSeenAtOrigin}`;
          elem.cycle_details = [];
          if (!maxTime || maxTime < elem.TripTime) maxTime = elem.TripTime;
          cyclesList.push(elem);
        });
        avgTime = avgTime / temp[key].length;
        list.push({
          DeviceID: key,
          numberOfCycles: temp[key].length,
          AvgRoundTripTimeHrs: avgTime,
          MaxCycleTime: maxTime,
          Variation: `${Math.round(((maxTime - avgTime) / avgTime) * 10000) / 100}%`,
          cycles: cyclesList,
        });
      });

      this.computed_cycles_list1 = list;
    },
    async get_cycle_data(duration) {
      this.is_loading = true;
      this.cycles_list = [];
      this.$store.dispatch(`show_label`);
      this.cycle_details1 = [];
      this.network_error = false;
      const response = await axios_get(tracking.get_cycle_data, {
        duration: duration || this.cycle_duration,
        locationId: this.locationId,
        includeMidCycle: this.includeMidCycle ? 1 : 0,
      });
      if (duration) this.cycles_overtime_list = response;
      else this.cycles_list = response;
      this.total_cycles = this.cycles_list.length;
      this.compute_cycle_list(this.cycles_list);
      this.total_cycles_devices = this.computed_cycles_list1.length;
      this.get_cycle_stats();
      this.is_loading = false;
    },
    async get_cycle_stats() {
      this.$store.dispatch(`show_label`);
      this.network_error = false;
      const response = await axios_get(tracking.get_cycle_stats, {
        duration: this.cycle_duration,
        locationId: this.locationId,
        includeMidCycle: this.includeMidCycle ? 1 : 0,
      });
      let temp = [
        [
          "Week",
          "Avg. Cycle Time",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
      ];
      let tempList = [];
      this.cycles_overtime_list = response
        .slice(0)
        .reverse()
        .map((elem) => {
          tempList[elem.WeekNumber - 1] = [
            `Week ${elem.WeekNumber}`,
            elem.AvgCycleTime,
            this.$options.filters.timeSince(elem.AvgCycleTime),
          ];
        });
      tempList.reverse().map((elem) => {
        temp.push(elem);
      });
      this.cycles_overtime_list = temp;
    },
    async get_assests_stats() {
      this.network_error = false;
      this.locationId = this.$route.params.locationId || (this.location_detail && this.location_detail.LocationID);
      const response = await axios_get(tracking.get_assests_stats, {
        locationId: this.locationId,
        week: this.asset_arrival_week,
      });
      this.timely_distribution = {};
      response.map((elem) => {
        this.timely_distribution[elem["HourArrived"]] = this.timely_distribution[elem["HourArrived"]] || [];
        this.timely_distribution[elem["HourArrived"]][elem["DayArrived"]] = elem["TotalArrived"];
      });
      this.max_inactive_assets = Math.max.apply(
        Math,
        response.map(function (o) {
          return o.TotalArrived;
        })
      );
    },
    async get_location_data() {
      this.network_error = false;
      this.locationId = this.$route.params.locationId || (this.location_detail && this.location_detail.LocationID);
      if (this.$route.params.locationId) {
        this.$store.commit("clear_search");
        this.no_search = false;
      }

      this.get_journeys_data();
      let location_res = await axios_get(tracking.get_location_details, { locationId: this.locationId });
      let watchlist_res = await axios_get(tracking.get_watchlisted_locations);
      let device_data_res = await axios_get(tracking.fetch_devices_at_POI, { id: this.locationId });
      let stats_res = await axios_get(tracking.get_location_stats);
      this.location_details = location_res[0];
      var stats_data = stats_res.filter((elem) => elem.FullName == this.location_details.FullName)[0];
      this.format_graph_data(device_data_res);
      this.devices_list = device_data_res;
      if (this.location_details) {
        this.watchlisted_devices = watchlist_res.map((elem) => elem.LocationID.toString());
        this.location_details["IsWatchlisted"] =
          this.watchlisted_devices.indexOf(this.locationId.toString()) == -1 ? false : true;
        this.location_details["FlowRate"] = stats_data["FlowRate"];
        this.location_details["Utilisation"] = stats_data["Utilisation"];
        this.location_details["TotalAssets"] = this.devices_list.length;
        this.location_details["CurrentLat"] = this.location_details["Latitude"];
        this.location_details["CurrentLng"] = this.location_details["Longitude"];
        this.$store.commit("update_page_title", `POI / ${this.location_details.FullName}`);
      }
    },
    filter_journeys_data(response) {
      return response.filter((elem) => {
        return elem.OriginID == this.locationId || elem.DestinationID == this.locationId;
      });
    },
    filter_journeys_list() {
      return this.devices_list.filter((elem) => elem.DeviceID == this.deviceId);
    },
    update_cycle_list(list) {
      return list.map((cycles) => {
        cycles.cycles.map((cycle_details) => {
          if (
            cycle_details.cycle_details.length == 0 &&
            this.cycle_details[
              `${cycle_details.DeviceID}_${cycle_details.LastSeenAtOrigin}_${cycle_details.ArrivalTimeAtDestination}`
            ]
          ) {
            this.cycle_details[
              `${cycle_details.DeviceID}_${cycle_details.LastSeenAtOrigin}_${cycle_details.ArrivalTimeAtDestination}`
            ].map((elem) => {
              cycle_details.cycle_details.push(elem);
            });
          }
          return cycle_details;
        });
        return cycles;
      });
    },
    format_chart_data(cycle_list) {
      let devices_inside = [];
      let devices_outside = [];
      let temp = {
        "Inside Plant": 0,
        "Outside Plant": 0,
        "Devices Inside Plant": 0,
        "Devices Outside Plant": 0,
        "Average Cycle Time Inside Plant": 0,
        "Average Cycle Time Outside Plant": 0,
      };
      cycle_list.map((elem) => {
        if (elem.FinalPoint == elem.StartPoint) {
          temp["Inside Plant"] = temp["Inside Plant"] + 1;
          temp["Average Cycle Time Inside Plant"] = temp["Average Cycle Time Inside Plant"] + elem.TripTime;
          if (devices_inside.indexOf(elem.DeviceID) == -1) devices_inside.push(elem.DeviceID);
        } else {
          temp["Outside Plant"] = temp["Outside Plant"] + 1;
          temp["Average Cycle Time Outside Plant"] = temp["Average Cycle Time Outside Plant"] + elem.TripTime;
          if (devices_outside.indexOf(elem.DeviceID) == -1) devices_outside.push(elem.DeviceID);
        }
      });
      temp["Devices Inside Plant"] = devices_inside.length;
      temp["Devices Outside Plant"] = devices_outside.length;
      temp["Average Cycle Time Outside Plant"] = temp["Average Cycle Time Outside Plant"] / temp["Outside Plant"];
      temp["Average Cycle Time Inside Plant"] = temp["Average Cycle Time Inside Plant"] / temp["Inside Plant"];
      return temp;
    },
  },
  computed: {
    computed_cycle_details: function () {
      return this.cycle_details;
    },
    location_devices: function () {
      return this.devices_list.filter((elem) => {
        return elem.FullName == this.location_details.FullName;
      });
    },
    computed_location_details: {
      get: function () {
        return this.location_detail || this.location_details;
      },
    },
    get_center: function () {
      return new window.google.maps.LatLng(
        this.computed_location_details.Latitude,
        this.computed_location_details.Longitude
      );
    },
    arrival_time_color: function () {
      let temp =
        this.max_inactive_assets % 5 == 0 ? this.max_inactive_assets / 5 : Math.round(this.max_inactive_assets / 5) + 1;
      let min = 0;
      let max = temp;
      this.page_content.arrival_time.colors;
      return this.page_content.arrival_time.colors.map((elem, index) => {
        min = index * temp + 1;
        max = (index + 1) * temp + 1;
        return {
          color: elem,
          max: max,
          min: min,
        };
      });
    },
    computed_tabs: function () {
      if (this.page_content) {
        let tabs = JSON.parse(JSON.stringify(this.page_content.tabs));
        let isPlant =
          this.computed_location_details.LocationCategory &&
          this.computed_location_details.LocationCategory.toLowerCase().trim() == "plant";
        return tabs.filter((elem, i) => {
          return i == 2 && isPlant ? true : i == 2 ? false : true;
        });
      }
      return null;
    },
    computed_cycles_list: function () {
      return this.cycles_list
        ? this.cycles_list.map((elem, i) => {
            elem.id = `${i}_${elem.DeviceID}`;
            return elem;
          })
        : null;
    },
    avg_cycle_time: function () {
      let cycle_time = 0;
      if (this.cycles_list) {
        this.cycles_list.map((elem) => {
          cycle_time = cycle_time + elem.TripTime;
        });
        cycle_time = cycle_time / this.cycles_list.length;
      }
      return cycle_time;
    },
    total_assets: function () {
      return this.device_status["Fluid"] + this.device_status["Static"];
    },
    donut_data: function () {
      return this.status_chart_data.length > 0
        ? [
            [
              "Device Status",
              "Number of Assets",
              {
                role: "tooltip",
                type: "string",
                p: { html: true, role: "tooltip" },
              },
            ],
            [
              "At Plant",
              this.status_chart_data[0]["TotalAtPlant"],
              {
                msg: "Devices at the plant.",
                title: "At Plant",
                footer: this.status_chart_data[0]["TotalAtPlant"],
              },
            ],
            [
              "Mid Cycle",
              this.status_chart_data[0]["MidCycle"],
              {
                msg: "Devices mid cycle.",
                title: " Mid cycle",
                footer: this.status_chart_data[0]["MidCycle"],
              },
            ],
            [
              "Slow Devices",
              this.status_chart_data[0]["SlowDevices"],
              {
                msg: "Devices moving slow",
                title: "Slow",
                footer: this.status_chart_data[0]["SlowDevices"],
              },
            ],
          ]
        : [];
    },
    outside_network: function () {
      return this.status_chart_data.length > 0 ? this.status_chart_data[0]["CurrentlyOutsideNetwork"] : null;
    },
    total_fleet_assets: function () {
      return this.$store.state.devices ? this.$store.state.devices.length : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
div.bottom-border {
  border-bottom: 1px solid var(--v-restingOutline-base);
}

div.top-border {
  border-top: 1px solid var(--v-restingOutline-base);
}

div.tab-highlighted {
  border-bottom: 4px solid var(--v-borderDark-base);
}

.pointer,
div.dashboard_tab {
  cursor: pointer;
}

.pointer-con .value-con {
  text-decoration: underline;
}

div.right-border {
  border-right: 1px solid var(--v-borderLight-base);
}

div.add-border {
  border: 1px solid var(--v-restingOutline-base);
}

::v-deep .right-border {
  border-right: 1px solid var(--v-border-base);
}

div.fixd-tile {
  height: 8px;
  width: 38px;
}

.no-style:hover {
  text-decoration: none;
}

.location_stats div.d-flex div {
  width: 50%;
}

div.fixd-legend-tile {
  height: 15px;
  width: 50px;
}

.location-container .title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
}

div.graph-sub-heading {
  color: var(--v-primaryGrey-base);
  font-size: 0.5rem;
  font-weight: bold;
}

.close-btn {
  position: absolute;
  top: -0.7rem;
  right: 0;
  z-index: 9;
  padding: 1em;
}

.download-btn {
  position: absolute;
  right: 3.8em;
  z-index: 9;
  padding: 1em;
}

.device_details .title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
}
</style>
